const env = (window as any).env || {}

const configValue = (key: string, fallback?: string): string => {
    const value = env[key] || process.env[`REACT_APP_${key}`] || fallback
    if (value === undefined && process.env.NODE_ENV === 'development') {
        throw new Error(`no value found for config key ${key}`)
    }
    return value
}

const appConfig = {
    backendApiUrl: configValue('BACKEND_API_URL', ''),
    sentryDSN: configValue('SENTRY_DSN', ''),
    clientId: configValue('AZURE_CLIENT_ID', ''),
    redirectUri: configValue('REDIRECT_URI', ''),
    muiLicenceKey: configValue('MUI_LICENCE_KEY', ''),
    keycloak: {
        url: `${configValue('KEYCLOAK_BASE_URL', 'https://qa.authn.ebmpapst.net')}`,
        realm: configValue('KEYCLOAK_REALM', 'ebm-papst'),
        clientId: configValue('KEYCLOAK_CLIENT_ID', 'fanscout-customer-api-key-management')
    }
}

export default appConfig
